import { render, staticRenderFns } from "./InboxEmailPanel.vue?vue&type=template&id=7cfb2e87&scoped=true"
import script from "./InboxEmailPanel.vue?vue&type=script&lang=js"
export * from "./InboxEmailPanel.vue?vue&type=script&lang=js"
import style0 from "./InboxEmailPanel.vue?vue&type=style&index=0&id=7cfb2e87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfb2e87",
  null
  
)

export default component.exports